import { FC, useContext } from 'react';
import { TableContext } from 'src/app/providers/TableProvider';
import { Button } from 'src/shared/ui';

export const TableButtons: FC = () => {
  const { resetTableData, saveRows, isLoading, setIsEdit } = useContext(TableContext);

  const onCancel = () => {
    resetTableData();
    setIsEdit(false);
  };

  return (
    <div className="ml-auto flex flex-wrap items-stretch justify-end gap-3">
      <Button
        classNames="w-full sm:w-56"
        variant="violet"
        onClick={() => saveRows()}
        disabled={isLoading}
      >
        Сохранить
      </Button>

      <Button
        classNames="h-auto w-full whitespace-normal px-3 py-2 text-center leading-tight sm:w-64"
        variant="violetOutline"
        onClick={() => saveRows({ includeDependentRules: true })}
        disabled={isLoading}
      >
        Сохранить + зависимые правила
      </Button>

      <Button classNames="w-full sm:w-56" variant="grey" onClick={onCancel} disabled={isLoading}>
        Отменить
      </Button>
    </div>
  );
};
